import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Tags } from '../lib/supabase';
import slugify from 'slugify';

export function useTags() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [tags, setTags] = useState<Tags[]>([]);

  useEffect(() => {
    const loadTags = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('tags')
          .select('*')
          .order('name');

        if (error) throw error;

        setTags(data as Tags[]);
      } catch (err) {
        console.error('Error fetching tags:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadTags();
  }, []);

  const createTag = async (name: string) => {
    setLoading(true);
    setError(null);

    try {
      const slug = slugify(name, { lower: true, strict: true });
      const { data, error } = await supabase
        .from('tags')
        .insert([{ name, slug }])
        .select()
        .single();

      if (error) throw error;

      setTags(prevTags => [...prevTags, data]);
      return data;
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    tags,
    createTag
  };
}